module.exports = __webpack_public_path__ + "static/img/imac_mockup.89bc01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imac_mockup.png
// module id = DuWb
// module chunks = 1